<div class="client-reviews-container font-inter">
    <div class="client-reviews-content container">
        <div class="top-section">
            <p class="title font-poppins">From The Hearts of Our Community</p>
            <p class="subtitle">Real reviews from happy families</p>
        </div>

        <div class="bottom-section">
            @for (review of reviews; track $index) {
            <div class="section">
                <div class="icon-container">
                    @for (star of [].constructor(review.rating); track $index) {
                    <mat-icon [svgIcon]="'fullstar'" class="star-icon"></mat-icon>
                    }
                </div>
                <p class="section-title">"{{ review.review }}"</p>

                <div class="image-name-container">
                    <img src="{{ review.image }}" alt="image" class="image" />
                    <div>
                        <p class="name">{{ review.name }}</p>
                        <p class="date">{{ review.date }}</p>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</div>
